// import axios from "axios";

// const { REACT_APP_REST_BACKEND_URL } = process.env;

// const students_url =  REACT_APP_REST_BACKEND_URL + "/students";

// export const fetchStudents = () => axios.get(students_url);
// export const createStudent = (newstudent) => axios.post(students_url, newstudent);
// export const updateStudent = (updatedstudent) =>
//   axios.put(`${students_url}/${updatedstudent.id}`, updatedstudent);
// export const deleteStudent = (deletestudentId) =>
//   axios.delete(`${students_url}/${deletestudentId}`);

import { gql } from "@apollo/client";

export const GET_INITIAL_STATE = gql`
  query initialState {
    initialState {
      students {
        _id
        name
        document
        phone
        debt
        mail
        birthdate
        city
        church
        education_level
        ocupation
        address
        currency
        pendingMandatorySubjectCodes
        enrollments {
          _id
          student {
            _id
            name
            document
            phone
            debt
            mail
            birthdate
            city
            church
            education_level
            pendingMandatorySubjectCodes
          }
          subjectInstance {
            _id
            subject {
              name
              abbreviation
            }
            startDate
            endDate
            price
            schedule
            zoom_link
          }
          grade
          status
          schedule
          attendances {
            _id
            status
            date
            enrollment {
              _id
            }
          }
        }
      }
      subjectInstances {
        _id
        subject {
          name
          abbreviation
        }
        price
        startDate
        endDate
        schedule
        zoom_link
        assignments {
          _id
          name
          description
          dueDate
          grades {
            _id
            student {
              _id
              name
            }
            grade
          }
          subjectInstance {
            _id
            subject {
              _id
              name
            }
          }
        }
      }
    }
  }
`;
export const LOGIN = gql`
  mutation login($input: UserInfo!) {
    login(input: $input) {
      token
      students {
        _id
        name
        document
        phone
        debt
        mail
        birthdate
        city
        church
        education_level
        ocupation
        address
        currency
        pendingMandatorySubjectCodes
        enrollments {
          _id
          student {
            _id
            name
            document
            phone
            debt
            mail
            birthdate
            city
            church
            education_level
            pendingMandatorySubjectCodes
          }
          subjectInstance {
            _id
            subject {
              name
              abbreviation
            }
            startDate
            price
            endDate
            schedule
            zoom_link
          }
          grade
          status
          schedule
          attendances {
            _id
            status
            date
            enrollment {
              _id
            }
          }
        }
      }
      subjectInstances {
        _id
        subject {
          name
          abbreviation
        }
        startDate
        endDate
        schedule
        zoom_link
        price
        assignments {
          _id
          name
          description
          dueDate
          grades {
            _id
            student {
              _id
              name
            }
            grade
          }
          subjectInstance {
            _id
            subject {
              _id
              name
            }
          }
        }
      }
    }
  }
`;
/////STUDENT

export const GET_STUDENTS = gql`
  query getAllStudents {
    students {
      _id
      name
      document
      phone
      debt
      mail
      birthdate
      city
      church
      education_level
      pendingMandatorySubjectCodes
      enrollments {
        _id
        student {
          _id
          name
          document
          phone
          debt
          mail
          birthdate
          city
          church
          education_level
          pendingMandatorySubjectCodes
        }
        subjectInstance {
          _id
          subject {
            name
            abbreviation
          }
          startDate
          endDate
          schedule
          zoom_link
        }
        grade
        status
        schedule
        attendances {
          _id
          status
          date
          enrollment {
            _id
          }
        }
      }
    }
  }
`;

export const ADD_STUDENT = gql`
  mutation CreateStudent($input: CreateStudentInput!) {
    createStudent(input: $input) {
      _id
      name
      document
      birthdate
      phone
      mail
      city
      church
      education_level
      ocupation
      address
      currency
      debt
      pendingMandatorySubjectCodes
    }
  }
`;
export const UPDATE_STUDENT = gql`
  mutation UpdateStudent($input: UpdateStudentInput!) {
    updateStudent(input: $input) {
      _id
      name
      document
      birthdate
      phone
      mail
      city
      church
      education_level
      ocupation
      address
      currency
      pendingMandatorySubjectCodes
      enrollments {
        _id
        subjectInstance {
          subject {
            name
            abbreviation
          }
        }
        grade
        status
        assignments {
          name
          grades {
            grade
          }
        }
      }
    }
  }
`;
export const DELETE_STUDENT = gql`
  mutation deleteStudent($input: ID!) {
    deleteStudent(studentId: $input)
  }
`;

/////SUBJECT

export const GET_SUBJECTS = gql`
  query getSubjects {
    subjects {
      _id
      name
      abbreviation
      isMandatory
    }
  }
`;
export const ADD_SUBJECT = gql`
  mutation CreateSubject($input: CreateSubjectInput!) {
    createSubject(input: $input) {
      _id
      name
      abbreviation
      isMandatory
    }
  }
`;
export const UPDATE_SUBJECT = gql`
  mutation updateSubject($input: UpdateSubjectInput!) {
    updateSubject(input: $input) {
      _id
      name
      abbreviation
      isMandatory
    }
  }
`;
export const DELETE_SUBJECT = gql`
  mutation deleteSubject($input: ID!) {
    deleteSubject(subjectId: $input)
  }
`;

/////SUBJECT INSTANCE
export const GET_ACTIVE_SUBJECT_INSTANCES = gql`
  query getCurrentSubjectInstances {
    subjectInstances {
      _id
      subject {
        name
        abbreviation
      }
      startDate
      endDate
      schedule
      zoom_link
      assignments {
        _id
        name
        description
        dueDate
        grades {
          _id
          student {
            _id
            name
          }
          grade
        }
        subjectInstance {
          _id
          subject {
            _id
            name
          }
        }
      }
    }
  }
`;

export const GET_SUBJECT_INSTANCES = gql`
  query getSubjectInstances {
    subjectInstances {
      _id
      subject {
        name
        abbreviation
      }
      schedule
      startDate
      endDate
      zoom_link
      enrollments {
        _id
        grade
        status
        student {
          _id
          name
        }
        attendances {
          status
        }
      }
      assignments {
        _id
        name
        dueDate
        grades {
          _id
          student {
            _id
            name
          }
          assignment {
            _id
            name
            subjectInstance {
              _id
              subject {
                _id
                name
              }
            }
          }
          grade
        }
        subjectInstance {
          _id
          subject {
            _id
            name
          }
        }
      }
    }
  }
`;
export const ADD_SUBJECT_INSTANCE = gql`
  mutation createSubjectInstance($input: CreateSubjectInstanceInput!) {
    createSubjectInstance(input: $input) {
      startDate
      endDate
      price
      schedule
      zoom_link
      _id
      subject {
        _id
        name
        abbreviation
      }
    }
  }
`;
export const UPDATE_SUBJECT_INSTANCE = gql`
  mutation UpdateSubjectInstance($input: UpdateSubjectInstanceInput!) {
    updateSubjectInstance(input: $input) {
      startDate
      endDate
      price
      schedule
      zoom_link
      _id
      subject {
        _id
        name
        abbreviation
      }
    }
  }
`;
export const DELETE_SUBJECT_INSTANCE = gql`
  mutation deleteSubjectInstance($input: ID!) {
    deleteSubjectInstance(subjectInstanceId: $input)
  }
`;

/////ENROLLMENT

export const GET_ENROLLMENTS = gql`
  query getEnrollments {
    enrollments {
      _id
      grade
      status
      schedule
      student {
        _id
        name
      }
      attendances {
        status
      }
    }
  }
`;

export const ADD_ENROLLMENT = gql`
  mutation createEnrollment($input: CreateEnrollmentInput!) {
    createEnrollment(input: $input) {
      _id
      grade
      status
      schedule
      student {
        _id
        name
        document
        birthdate
        phone
        mail
        city
        church
        education_level
        ocupation
        address
        currency
        debt
        pendingMandatorySubjectCodes
      }
      attendances {
        _id
      }
      subjectInstance {
        _id
        subject {
          name
          abbreviation
        }
        schedule
        assignments {
          _id
        }
      }
    }
  }
`;

export const UPDATE_ENROLLMENT = gql`
  mutation UpdateEnrollment($input: UpdateEnrollmentInputnew!) {
    updateEnrollment(input: $input) {
      _id
      grade
      status
      schedule
      student {
        _id
        name
        document
        birthdate
        phone
        mail
        city
        church
        education_level
        ocupation
        address
        currency
        pendingMandatorySubjectCodes
      }
      attendances {
        _id
      }
      subjectInstance {
        _id
        subject {
          name
          abbreviation
        }
        schedule
        assignments {
          _id
        }
      }
    }
  }
`;
export const DELETE_ENROLLMENT = gql`
  mutation deleteEnrollment($input: ID!) {
    deleteEnrollment(enrollmentId: $input)
  }
`;

/////ASSIGNMENT
export const GET_ASSIGNMENTS = gql`
  query getAssignments {
    assignments {
      _id
      name
      description
      dueDate
      subjectInstance {
        _id
        subject {
          _id
          name
        }
      }
      grades {
        _id
        student {
          _id
          name
        }
        grade
      }
    }
  }
`;
export const ADD_ASSIGNMENT = gql`
  mutation CreateAssignment($input: CreateAssignmentInput!) {
    createAssignment(input: $input) {
      _id
      name
      description
      dueDate
      subjectInstance {
        _id
        subject {
          _id
          name
        }
      }
    }
  }
`;
export const UPDATE_ASSIGNMENT = gql`
  mutation UpdateAssignment($input: UpdateAssignmentInput!) {
    updateAssignment(input: $input) {
      _id
      name
      description
      dueDate
      subjectInstance {
        _id
        subject {
          _id
          name
        }
      }
    }
  }
`;
export const DELETE_ASSIGNMENT = gql`
  mutation deleteAssignment($input: ID!) {
    deleteAssignment(assignmentId: $input)
  }
`;

//GRADE
// export const GET_GRADES = gql`
// `;
export const ADD_GRADE = gql`
  mutation AddGrade($input: CreateGradeInput!) {
    createGrade(input: $input) {
      _id
      student {
        _id
        name
      }
      assignment {
        _id
        name
        subjectInstance {
          _id
          subject {
            _id
            name
          }
        }
      }
      grade
    }
  }
`;
export const UPDATE_GRADE = gql`
  mutation UpdateGrade($input: UpdateGradeInput!) {
    updateGrade(input: $input) {
      _id
      student {
        _id
        name
      }
      assignment {
        _id
        name
        subjectInstance {
          _id
          subject {
            _id
            name
          }
        }
      }
      grade
    }
  }
`;
export const DELETE_GRADE = gql`
  mutation deleteGrade($input: ID!) {
    deleteGrade(gradeId: $input)
  }
`;
//ATTENDANCE
export const GET_ATTENDANCE_CODE = gql`
  mutation generateAttendanceCode($input: ID!) {
    generateAttendanceCode(subjectInstanceId: $input) {
      code
      expirationDate
      isaNewCode
    }
  }
`;

export const MARK_ATTENDANCE = gql`
  mutation markAttendance($input: MarkAttendanceInput!) {
    markAttendance(input: $input) {
      _id
      status
      date
      student {
        _id
        document
        name
      }
      enrollment {
        _id
      }
    }
  }
`;
export const GET_ATTENDANCES = gql`
  query getAttendances {
    attendances {
      _id
      status
      date
      student {
        _id
        document
        name
      }
      enrollment {
        _id
        schedule
      }
    }
  }
`;
// export const ADD_ATTENDANCE= gql`
// `;
export const UPDATE_ATTENDANCE = gql`
  mutation updateAttendance($input: UpdateAttendanceInput!) {
    updateAttendance(input: $input) {
      _id
      status
      date

      enrollment {
        _id
        student {
          _id
          name
        }
        schedule
        subjectInstance {
          _id
          subject {
            _id
            name
          }
          schedule
        }
      }
    }
  }
`;
// export const DELETE_ATTENDANCE= gql`
// `;
//PAYMENT_RECORDS

export const GET_PAYMENT_RECORDS = gql`
  query getPaymentRecords {
    paymentRecords {
      _id
      amount
      currency
      paymentDate
      student {
        _id
        name
      }
    }
  }
`;
export const ADD_PAYMENT_RECORD = gql`
  mutation createPaymentRecord($input: CreatePaymentRecordInput!) {
    createPaymentRecord(input: $input) {
      _id
      amount
      paymentDate
      currency
      student {
        _id
        name
      }
    }
  }
`;
export const UPDATE_PAYMENT_RECORD = gql`
  mutation updatePaymentRecord($input: UpdatePaymentRecordInput!) {
    updatePaymentRecord(input: $input) {
      _id
      amount
      currency
      paymentDate
      student {
        _id
        name
      }
    }
  }
`;
export const DELETE_PAYMENT_RECORD = gql`
  mutation deletePaymentRecord($input: ID!) {
    deletePaymentRecord(paymentRecordId: $input)
  }
`;

export const INCREASE_STUDENT_DEBT = gql`
  mutation increaseDebtOfStudents($input: IncreaseDebtInput!) {
    increaseDebtOfStudents(input: $input)
  }
`;
export const GET_TUITION_VALUES = gql`
  query getTuitionValues {
    tuitionValues {
      values
      currency
    }
  }
`;
export const ADD_TUITION_VALUES = gql`
  mutation addTuitionValues($input: TuitionValuesInput!) {
    addTuitionValues(input: $input) {
      currency
      values
    }
  }
`;
export const UPDATE_TUITION_VALUES = gql`
  mutation updateTuitionValues($input: TuitionValuesInput!) {
    updateTuitionValues(input: $input) {
      values
      currency
    }
  }
`;
